import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import ModuleQuestion from "../../components/ModuleQuestion";
import { SideBar } from "../../components/SideBar";
import { useSelector } from "react-redux";

import { ReactLoaderSpinner } from "../../components/ReactLoaderSpinner/index.js";

// services
import { useBookmarkModuleMutation } from "../../store/services/moduleServerApi";

const Module_4_1_10 = () => {
  const moduleNumber = 4;
  const { pathname: pathName } = useLocation();
  const { menuItems } = useSelector((state) => state?.moduleSlice);


  const [bookmarkModule, { isLoading: isMenuLoading }] =
    useBookmarkModuleMutation();

  /* Start useEffect */
  useEffect(() => {
    bookmarkModule({ pathName });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // * onPageLoad
  /* End useEffect */

  return (
    <div className="row">
      {isMenuLoading && <ReactLoaderSpinner />}
      {menuItems?.id && <SideBar menuItems={[menuItems]} moduleNumber={moduleNumber} />}

      <main className="col-sm-8 module-content">
        <section>
          <h1 className="blue text-uppercase b mt-5 mb-4">4.1.10 Case 10</h1>
          <p className="me-4">Estimated time to complete: 3-5 minutes</p>
        </section>
        <ModuleQuestion
          correctAnswer="A"
          assessmentName="challenge_case_10"
          videoTranscript={
            <>
              <p>
                <strong>AUDIO</strong>
                <br />
                VO: (FEMALE)
                <br />
                This is challenge case number 10. This is a positive case.
                Beginning at the level of the cerebellum and moving superiorly,
                we enter into the temporal and occipital lobes, seen here.
                Intense activity is seen in the left occipital lobe.
              </p>
              <p>
                This activity, which is located within the gray matter, is more
                intense than the activity in the surrounding white matter. This
                finding alone would make this case positive. However, let’s
                continue to examine the remainder of the scan. In the rest of
                the temporal and occipital regions, there is loss of gray-white
                contrast. Distinct white matter tracts are not identifiable, and
                there is increased activity in the gray matter bilaterally.
                Therefore, the temporal and occipital regions are positive.
              </p>
              <p>
                As we enter into the frontal regions, identified here, distinct
                white matter tracts are not identifiable. There is increased
                activity in the gray matter and loss of gray-white contrast
                throughout.
              </p>
              <p>
                On the right-hand side, however, a large area of reduced to
                absent activity is seen encompassing the frontal cortex,
                extending posteriorly. This is likely due to a previous stroke.
                For confirmation, the fused images can be used. This loss of
                gray-white contrast is secondary to loss of activity both in the
                gray matter and white matter.
              </p>
              <p>
                It is important to realize this difference, as posterior to this
                abnormality, there is also loss of gray-white contrast, but this
                loss of gray-white contrast is due to increased activity in the
                gray matter.
              </p>
              <p>
                Continuing upward, there is continued loss of gray-white
                contrast both in the frontal cortices and, as we enter into the
                parietal regions, loss of gray-white contrast is also seen here,
                both on the left- and right- hand side. This area of near-absent
                to absent activity also is persistent. In the posterior parietal
                region, once again distinct white matter tracts are not
                identifiable, and the normally seen white matter tracts, which
                proceed from the front of the brain to the back of the brain,
                are not identified.
              </p>
              <p>
                In the medial parietal region, which includes the precuneus,
                increased activity is seen in the gray matter. On the sagittal
                images, this can be clearly seen in this region, here.
              </p>
              <p>
                After reviewing the remainder of the slices in the parietal region, there is continued loss of gray-white contrast. Therefore, as there is loss of gray-white contrast in the parietal, temporal, and left frontal regions, as well as focal uptake in the left occipital region, this case is positive. If you called this case negative, you may want to review the case once again in the MIMcloud Viewer.
              </p>
            </>
          }
          previousLesson="/module-4/module-4-1-9"
          nextLesson="/module-4/module-4-1-11"
          iframeURL="https://cdnapisec.kaltura.com/p/1759891/sp/175989100/embedIframeJs/uiconf_id/24639831/partner_id/1759891?iframeembed=true&playerId=kaltura_player_312563040&entry_id=1_x85j355q&wid=_1759891&flashvars[sideBarContainer.plugin]=true&flashvars[sideBarContainer.position]=left&flashvars[sideBarContainer.clickToClose]=true&flashvars[chapters.plugin]=true&flashvars[chapters.layout]=vertical&flashvars[chapters.thumbnailRotator]=false&flashvars[streamSelector.plugin]=true&flashvars[EmbedPlayer.SpinnerTarget]=videoHolder&flashvars[dualScreen.plugin]=true"
          videoId="1_x85j355q"
        />
      </main>
    </div>
  );
};

export default Module_4_1_10;
